module.exports = __webpack_public_path__ + "img/pro_ten_1.9b2f87d9.jpg";